import { IAllergy } from "../../../../interfaces/patient/IAllergy"
import { IIPastConditionItem, IPastConditionOnsetAge } from "../../../../interfaces/patient/IPastCondition"
import { ISurgeryItem } from "../../../../interfaces/patient/IPrescriptionSurgery"
import { IFamilyHistoryItem, IFamilyRelationItem } from "../../../../interfaces/patient/IFamilyHistory"

export const AllergenTypeOptions = [
	{
		value: "FOOD",
		label: "Food",
	},
	{
		value: "ENVIRONMENTAL",
		label: "Environmental",
	},
	{
		value: "DRUG",
		label: "Drugs",
	},
]

export const getEmptyAllergyItem = (): IAllergy => {
	return {
		allergen: null,
		allergenType: "",
		comments: "",
		isSuspected: false,
		q: null,
		updatingMethod: "",
		validSelection: false,
	}
}

export interface IInitialConfigType {
	id?: string
	diseaseName?: string
	description?: string
	isSelected?: boolean
	showDescription?: boolean
	conditionInputUiConfig?: IConditionInputUiConfigType
}

export interface IConditionInputUiConfigType {
	complicationCategoryKey?: string
	disease?: {
		displayValue?: string
		internalValue?: string
	}
	validSelection?: boolean
	q?: {
		displayValue?: string
		internalValue?: string
	}
	items?: any[]
}

export const createEmptyConditionItem = (): IIPastConditionItem => {
	return {
		disease: {
			displayValue: null,
			internalValue: null,
		},
		validSelection: false,
		items: [createEmptyOnsetAgeItem()],
	}
}

export const createEmptySurgeryItem = (): ISurgeryItem => {
	return {
		surgeryName: null,
		when: null,
		comments: null,
	}
}

export const createEmptyOnsetAgeItem = (): IPastConditionOnsetAge => {
	return {
		age: null,
		startMonth: null,
		startYear: null,
		tillDate: false,
		presentDate: null,
		comment: null,
	}
}
export const createEmptyFamilyRelationItem = (): IFamilyRelationItem => {
	return {
		relationship: null,
		tillDate: false,
		presentDate: null,
		comment: null,
	}
}

export const createEmptyFamilyHistoryItem = (): IFamilyHistoryItem => {
	return {
		disease: {
			displayValue: null,
			internalValue: null,
		},
		q: {
			displayValue: null,
			internalValue: null,
		},
		items: [createEmptyFamilyRelationItem()],
		validSelection: false,
		updatingMethod: "",
	}
}

export const pastConditionSuggestions: IInitialConfigType[] = [
	{
		id: "typeOneDiabetes",
		diseaseName: "Type 1 Diabetes",
		description: "",
		isSelected: false,
		showDescription: false,
		conditionInputUiConfig: {
			complicationCategoryKey: "typeOneDiabetes",
			disease: {
				displayValue: "Type 1 Diabetes",
				internalValue: "Type 1 Diabetes",
			},
			validSelection: false,
			q: {
				displayValue: "Type 1 Diabetes",
				internalValue: "Type 1 Diabetes",
			},
			items: [
				{
					age: null,
					startMonth: null,
					startYear: null,
					tillDate: false,
					presentDate: null,
					comment: null,
				},
			] as any,
		},
	},
	{
		id: "lada",
		diseaseName: "LADA",
		description: "",
		isSelected: false,
		showDescription: false,
		conditionInputUiConfig: {
			complicationCategoryKey: "lada",
			disease: {
				displayValue: "LADA",
				internalValue: "LADA",
			},
			validSelection: false,
			q: {
				displayValue: "LADA",
				internalValue: "LADA",
			},
			items: [
				{
					age: null,
					startMonth: null,
					startYear: null,
					tillDate: false,
					presentDate: null,
					comment: null,
				},
			] as any,
		},
	},
	{
		id: "mody",
		diseaseName: "MODY",
		description: "",
		isSelected: false,
		showDescription: false,
		conditionInputUiConfig: {
			complicationCategoryKey: "mody",
			disease: {
				displayValue: "MODY",
				internalValue: "MODY",
			},
			validSelection: false,
			q: {
				displayValue: "MODY",
				internalValue: "MODY",
			},
			items: [
				{
					age: null,
					startMonth: null,
					startYear: null,
					tillDate: false,
					presentDate: null,
					comment: null,
				},
			] as any,
		},
	},
	{
		id: "pancreatitis",
		diseaseName: "Pancreatitis",
		description: "serum creatinine value (>1.2 for women and >1.4 for men)",
		isSelected: false,
		showDescription: false,
		conditionInputUiConfig: {
			complicationCategoryKey: "pancreatitis",
			disease: {
				displayValue: "Pancreatitis",
				internalValue: "Pancreatitis",
			},
			validSelection: false,
			q: {
				displayValue: "Pancreatitis",
				internalValue: "Pancreatitis",
			},
			items: [
				{
					age: null,
					startMonth: null,
					startYear: null,
					tillDate: false,
					presentDate: null,
					comment: null,
				},
			] as any,
		},
	},
	{
		id: "chronicKidneyDiseases",
		diseaseName: "Chronic Kidney Diseases",
		description: "",
		isSelected: false,
		showDescription: false,
		conditionInputUiConfig: {
			complicationCategoryKey: "chronicKidneyDiseases",
			disease: {
				displayValue: "Chronic Kidney Diseases",
				internalValue: "Chronic Kidney Diseases",
			},
			validSelection: false,
			q: {
				displayValue: "Chronic Kidney Diseases",
				internalValue: "Chronic Kidney Diseases",
			},
			items: [
				{
					age: null,
					startMonth: null,
					startYear: null,
					tillDate: false,
					presentDate: null,
					comment: null,
				},
			] as any,
		},
	},
	{
		id: "ischemicHeartDisease",
		diseaseName: "IHD (Ischemic heart disease)",
		description: "People undergone Angioplasty/CABG. Congestive heart failure patients with known ejection fraction on 2 D echo less than 40%. Uncontrolled hypertension despite meds > 160/95 ",
		isSelected: false,
		showDescription: false,
		conditionInputUiConfig: {
			complicationCategoryKey: "ischemicHeartDisease",
			disease: {
				displayValue: "IHD (Ischemic Heart Disease)",
				internalValue: "IHD (Ischemic Heart Disease)",
			},
			validSelection: false,
			q: {
				displayValue: "IHD (Ischemic Heart Disease)",
				internalValue: "IHD (Ischemic Heart Disease)",
			},
			items: [
				{
					age: null,
					startMonth: null,
					startYear: null,
					tillDate: false,
					presentDate: null,
					comment: null,
				},
			] as any,
		},
	},
	{
		id: "mentalHealthDisorders",
		diseaseName: "Mental Health Disorders",
		description:
			"Alzheimer's ( type 3 diabetes) - Dementia with cognitive impairment, schizophrenia, Psychosis, known Bipolar Disorder on medications should be omitted from the criterion of reversal ",
		isSelected: false,
		showDescription: false,
		conditionInputUiConfig: {
			complicationCategoryKey: "mentalHealthDisorders",
			disease: {
				displayValue: "Mental Health Disorders",
				internalValue: "Mental Health Disorders",
			},
			validSelection: false,
			q: {
				displayValue: "Mental Health Disorders",
				internalValue: "Mental Health Disorders",
			},
			items: [
				{
					age: null,
					startMonth: null,
					startYear: null,
					tillDate: false,
					presentDate: null,
					comment: null,
				},
			] as any,
		},
	},
	{
		id: "disabilites",
		diseaseName: "Disabilities",
		description: "Paraplegia, quadriplegia, any disability that limits physical activity. Ex: knee osteoarthritis severe or hip Osteoarthritis.",
		isSelected: false,
		showDescription: false,
		conditionInputUiConfig: {
			complicationCategoryKey: "disabilites",
			disease: {
				displayValue: "Disabilities",
				internalValue: "Disabilities",
			},
			validSelection: false,
			q: {
				displayValue: "Disabilities",
				internalValue: "Disabilities",
			},
			items: [
				{
					age: null,
					startMonth: null,
					startYear: null,
					tillDate: false,
					presentDate: null,
					comment: null,
				},
			] as any,
		},
	},
]

export enum CareCatalogues {
	MEDICINE = "medicine_catalogue",
	DISEASE = "disease_catalogue",
	ALLERGY = "allergies_catalogue",
	SYMPTOMS = "symptom_catalogue",
	DIAGNOSTIC = "diagnostic_catalogue",
	LIFESTYLE_ADVICE = "lifestyle_advice_catalogue",
}

export const getCareCatalogueSearchPayload = (catalogue: CareCatalogues, queryStr: string): any => {
	switch (catalogue) {
		case CareCatalogues.MEDICINE: {
			return {
				size: 10,
				query: {
					function_score: {
						query: {
							bool: {
								should: [
									{
										match_phrase_prefix: {
											productName: {
												query: queryStr,
												slop: 0,
												max_expansions: 50,
												boost: 1,
											},
										},
									},
									{
										match_phrase_prefix: {
											molecule: {
												query: queryStr,
												slop: 0,
												max_expansions: 50,
												boost: 0.2,
											},
										},
									},
								],
								adjust_pure_negative: true,
								minimum_should_match: "1",
								boost: 1,
							},
						},
						functions: [
							{
								script_score: {
									script: {
										inline: "1+100000*doc['popularityScore'].value",
									},
								},
							},
						],
						score_mode: "multiply",
						boost_mode: "multiply",
					},
				},
			}
		}
		case CareCatalogues.DISEASE: {
			return {
				query: {
					function_score: {
						query: {
							bool: {
								should: [
									{
										match_phrase_prefix: {
											name: {
												query: queryStr,
												boost: 2,
											},
										},
									},
									{
										match_phrase_prefix: {
											alternateNames: {
												query: queryStr,
												boost: 1,
											},
										},
									},
								],
							},
						},
						functions: [
							{
								script_score: {
									script: {
										inline: "1+10000*doc['priority'].value",
									},
								},
							},
						],
						score_mode: "multiply",
						boost_mode: "multiply",
					},
				},
			}
		}
	}
}

export const FamilyRelationships = [
	{
		label: "Father",
		value: "Father",
	},
	{
		label: "Mother",
		value: "Mother",
	},
	{
		label: "Son",
		value: "Son",
	},
	{
		label: "Daughter",
		value: "Daughter",
	},
	{
		label: "Brother",
		value: "Brother",
	},
	{
		label: "Sister",
		value: "Sister",
	},
	{
		label: "Uncle",
		value: "Uncle",
	},
	{
		label: "Aunty",
		value: "Aunty",
	},
	{
		label: "Paternal Grandfather",
		value: "Paternal Grandfather",
	},
	{
		label: "Paternal Grandmother",
		value: "Paternal Grandmother",
	},
	{
		label: "Maternal Grandfather",
		value: "Maternal Grandfather",
	},
	{
		label: "Maternal Grandmother",
		value: "Maternal Grandmother",
	},
]

// @ts-ignore
export const clientProfessionTooltipContent = () => (
	<table style={{ width: "225px" }}>
		<tr>
			<td style={{ wordBreak: "keep-all" }}>Sedentary</td>
			<td>:</td>
			<td>Sitting, office work, selling produce, tending shop</td>
		</tr>
		<tr>
			<td style={{ wordBreak: "keep-all" }}>Moderate</td>
			<td>:</td>
			<td>Standing, carrying light loads</td>
		</tr>
		<tr>
			<td style={{ wordBreak: "keep-all" }}>Vigorous</td>
			<td>:</td>
			<td>Non-mechanized, agricultural, lifting</td>
		</tr>
	</table>
)

export const clientProfessionActivityType = [
	{ label: "Sedentary/Light Activity", value: "SEDENTARY_LIGHT" },
	{ label: "Moderate Activity", value: "MODERATE" },
	{ label: "Vigorous Activity", value: "VIGOROUS" },
]

export const weightLossOptions = [
	{ label: "Gain", value: "GAIN" },
	{ label: "Loss", value: "LOSS" },
	{ label: "Remained Steady", value: "STEADY" },
]

export const yesNoOptions = [
	{ label: "No", value: false },
	{ label: "Yes", value: true },
]

export const durationUnitOptions = [
	{ label: "Day", value: "DAY" },
	{ label: "Week", value: "WEEK" },
	{ label: "Month", value: "MONTH" },
	{ label: "Year", value: "YEAR" },
]

export enum HistoryPageComponents {
	ALLERGY = "ALLERGY",
	PAST_CONDITIONS = "PAST_CONDITIONS",
	SURGERY = "SURGERY",
	CURRENT_MEDICATION = "CURRENT_MEDICATION",
	FAMILY_HISTORY = "FAMILY_HISTORY",
	PAST_CONSULTATIONS = "PAST_CONSULTATIONS",
	PERSONAL_INFO = "PERSONAL_INFO",
	LMP = "LMP",
	TIME_PREFERENCE = "TIME_PREFERENCE",
}

export const HistoryPageComponentSequence = [
	HistoryPageComponents.ALLERGY,
	HistoryPageComponents.PAST_CONDITIONS,
	HistoryPageComponents.SURGERY,
	HistoryPageComponents.CURRENT_MEDICATION,
	HistoryPageComponents.FAMILY_HISTORY,
	// HistoryPageComponents.PAST_CONSULTATIONS,
	HistoryPageComponents.PERSONAL_INFO,
	HistoryPageComponents.LMP,
	HistoryPageComponents.TIME_PREFERENCE,
]

export const ComponentLabelMap = {
	[HistoryPageComponents.ALLERGY]: "Allergy",
	[HistoryPageComponents.PAST_CONDITIONS]: "Past Condition",
	[HistoryPageComponents.SURGERY]: "Surgery",
	[HistoryPageComponents.CURRENT_MEDICATION]: "Current Medication",
	[HistoryPageComponents.FAMILY_HISTORY]: "Family History",
	[HistoryPageComponents.PAST_CONSULTATIONS]: "Past Consultations",
	[HistoryPageComponents.PERSONAL_INFO]: "Personal Information",
	[HistoryPageComponents.LMP]: "LMP",
	[HistoryPageComponents.TIME_PREFERENCE]: "Time Preference",
}

export const InjuryOptions = [
	{ label: "Joint Injury(knee, ankle etc.)", value: "joint injury" },
	{ label: "Muscle injury (strain, tear, etc.)", value: "Muscle injury" },
	{ label: "Bone injury (fracture, etc.)", value: "Bone injury" },
	{ label: "Other", value: "other" },
]

export const FemaleConditions = [
	{ label: "Currently pregnant", value: "Currently pregnant" },
	{ label: "Postpartum (within the last 12 months)", value: "Postpartum (within the last 12 months)" },
	{ label: "Experiencing Menstrual Cycle-related symptoms that affect your exercise routine", value: "Experiencing Menstrual Cycle-related symptoms that affect your exercise routine" },
	{ label: "None of the above", value: "None of the above" },
]

export enum PastConditionAgeType {
	YEARS_AGO = "YEARS_AGO",
	YEAR_OF_DIAGNOSIS = "YEAR_OF_DIAGNOSIS",
	AGE_AT_DIAGNOSIS = "AGE_AT_DIAGNOSIS",
}

export const PastConditionAgeTypeOptions = [
		{
			label: "Years Ago",
			value: PastConditionAgeType.YEARS_AGO
		},
		{
			label: "Year of Diagnosis",
			value: PastConditionAgeType.YEAR_OF_DIAGNOSIS
		},
		{
			label: "Age at Diagnosis",
			value: PastConditionAgeType.AGE_AT_DIAGNOSIS
		},
	]